import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {Editor, EditorState, RichUtils, convertToRaw, convertFromRaw} from 'draft-js';
import 'draft-js/dist/Draft.css'
import styled from 'styled-components';
import Toolbar from "./containers/EditorToolbar";
import { customStyleFn } from "./containers/EditorToolbar/customStyles";
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  Visibility,
  Tab,
  Input,
  Label,
  Statistic,
  Modal,
  Form,
  Popup,
  Dropdown,
  Checkbox,
} from 'semantic-ui-react'
import {
  DateInput,
  TimeInput,
} from 'semantic-ui-calendar-react';
import firebase from './components/Firebase';

const db = firebase.firestore();

EditEvent.propTypes = {
  event: PropTypes.any.isRequired,
}

const EditorWrapper = styled.div`
min-width: 350px;
height: fit-content;
margin-top: 2em;
margin-bottom: 1em;
`;

const EditorContainer = styled.div`
min-height: 15em;
border-radius: 0 0 3px 3px;
background-color: #fff;
padding: 10px;
font-size: 17px;
font-weight: 300;
box-shadow: 0px 0px 3px 1px rgba(15, 15, 15, 0.17);
`;

export function EditEvent(props) {
  const storage = firebase.storage().ref();
  const {event} = props
  const docref= firebase.firestore().collection('Events').doc(event.uid);
  const [values, setValues] = React.useState({
    eventTitle: '',
    eventOrganizer: '',
    eventEmail: '',
    eventPhone: '',
    eventVenue: '',
    eventStreet1: '',
    eventStreet2: '',
    eventCity: '',
    eventProvince: '',
    eventDetails: '',
    ticketName: '',
    ticketDetails: '',
    ticketQuantity: 0,
    ticketPrice: 0.0,
    });
  const [eventCategory, setCategory] = React.useState();
  const [eventType, setType] = React.useState();
  const [eventCountry, setCountry] = React.useState();
  const [phoneCode, setCode] = React.useState('+237');
  const [editorState, setEditorState] = React.useState(EditorState.createEmpty());

  const updateEditorState = (editorState) => {
    setEditorState(editorState);
  }

  const handleKeyCommand = (command, editorState) => {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      setEditorState(newState);
      return 'handled';
    }
    return 'not-handled';
  }

  React.useEffect(() => {
    var contentState = convertFromRaw(event.eventDetails);
    setEditorState(EditorState.createWithContent(contentState));
  }, [])

  const handleCategory = (e, {value}) => {
    setCategory(value);
  }
  const handleType = (e, {value}) => {
    setType(value);
  }
  const handleCountry = (e, {value}) => {
    setCountry(value);
  }

  const handleCode = (e, {value}) => {
    setCode(value);
  }

  const [eventImage, setImage] = React.useState();
  const [prevUrl, setPrevUrl] = React.useState();
  const [eventPublic, setPublic] = React.useState(false);
  const [eventTickets, setTickets] = React.useState(false);

  const handlePublic = (e) => {
    setPublic(!eventPublic);
  }

  const handleTickets = (e) => {
    setTickets(!eventTickets);
  }

  const fileInputRef = React.createRef();

  const [startDate, setStartDate] = React.useState('');
  const [endDate, setEndDate] = React.useState('');
  const [startTime, setStartTime] = React.useState('');
  const [endTime, setEndTime] = React.useState('');
  const [salesStartDate, setSalesStartDate] = React.useState('');
  const [salesStartTime, setSalesStartTime] = React.useState('');
  const [salesEndDate, setSalesEndDate] = React.useState('');
  const [salesEndTime, setSalesEndTime] = React.useState('');

  const handleSalesStartDateChange = (event, {name, value}) => {
    setSalesStartDate(value);
  }

  const handleSalesEndDateChange = (event, {name, value}) => {
    setSalesEndDate(value);
  }

  const handleSalesStartTimeChange = (event, {name, value}) => {
    setSalesStartTime(value);
  }

  const handleSalesEndTimeChange = (event, {name, value}) => {
    setSalesEndTime(value);
  }

  const handleStartDateChange = (event, {name, value}) => {
      setStartDate(value);
  }
  const handleEndDateChange = (event, {name, value}) => {
      setEndDate(value);
  }
  const handleStartTimeChange = (event, {name, value}) => {
      setStartTime(value);
  }
  const handleEndTimeChange = (event, {name, value}) => {
      setEndTime(value);
  }
  const handleChange = name => event => {
    setValues({ ...values, [name]: event.target.value });
  };

  const handleImageChange = e => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setPrevUrl(URL.createObjectURL(e.target.files[0]));
    }
  }

  const [currencyCode, setCurrencyCode] = React.useState('');

  const handleCurrency = (e, {value}) => {
    setCurrencyCode(value);
  }

  const currency = [
    {key: 'XAF', text: 'XAF', value: 'XAF'},
    {key: 'EUR', text: '€', value: 'EUR'},
    {key: 'USD', text: '$', value: 'USD'},
  ]

  const categories = [
    {key: 'Sports', text: 'Sports', value: 'Sports'},
    {key: 'Music', text: 'Music', value: 'Music'},
    {key: 'Visual Arts', text: 'Visual Arts', value: 'Visual Arts'},
    {key: 'Performing Arts', text: 'Performing Arts', value: 'Performing Arts'},
    {key: 'Movie', text: 'Movie', value: 'Movie'},
    {key: 'Fashion', text: 'Fashion', value: 'Fashion'},
    {key: 'Festivals & Fairs', text: 'Festivals & Fairs', value: 'Festivals & Fairs'},
    {key: 'Charities', text: 'Charities', value: 'Charities'},
    {key: 'Kids & Family', text: 'Kids & Family', value: 'Kids & Family'},
    {key: 'Party', text: 'Party', value: 'Party'},
    {key: 'Business', text: 'Business', value: 'Business'},
    {key: 'Education', text: 'Education', value: 'Education'},
  ]

  const types = [
    {key: 'Indoors', text: 'Indoors', value: 'Indoors'},
    {key: 'Chillout', text: 'Chillout', value: 'Chillout'},
    {key: 'Nightlife', text: 'Nightlife', value: 'Nightlife'},
    {key: 'Reunion', text: 'Reunion', value: 'Reunion'},
    {key: 'Workshops', text: 'Workshops', value: 'Workshops'},
    {key: 'Casual', text: 'Casual', value: 'Casual'},
    {key: 'Conference', text: 'Conference', value: 'Conference'},
  ]

  const countries = [
    { key: 'af', value: 'Afghanistan', flag: 'af', text: 'Afghanistan' },
    { key: 'ax', value: 'Aland Islands', flag: 'ax', text: 'Aland Islands' },
    { key: 'al', value: 'Albania', flag: 'al', text: 'Albania' },
    { key: 'dz', value: 'Algeria', flag: 'dz', text: 'Algeria' },
    { key: 'as', value: 'American Samoa', flag: 'as', text: 'American Samoa' },
    { key: 'ad', value: 'Andorra', flag: 'ad', text: 'Andorra' },
    { key: 'ao', value: 'Angola', flag: 'ao', text: 'Angola' },
    { key: 'ai', value: 'Anguilla', flag: 'ai', text: 'Anguilla' },
    { key: 'ag', value: 'Antigua', flag: 'ag', text: 'Antigua' },
    { key: 'ar', value: 'Argentina', flag: 'ar', text: 'Argentina' },
    { key: 'am', value: 'Armenia', flag: 'am', text: 'Armenia' },
    { key: 'aw', value: 'Aruba', flag: 'aw', text: 'Aruba' },
    { key: 'au', value: 'Australia', flag: 'au', text: 'Australia' },
    { key: 'at', value: 'Austria', flag: 'at', text: 'Austria' },
    { key: 'az', value: 'Azerbaijan', flag: 'az', text: 'Azerbaijan' },
    { key: 'bs', value: 'Bahamas', flag: 'bs', text: 'Bahamas' },
    { key: 'bh', value: 'Bahrain', flag: 'bh', text: 'Bahrain' },
    { key: 'bd', value: 'Bangladesh', flag: 'bd', text: 'Bangladesh' },
    { key: 'bb', value: 'Barbados', flag: 'bb', text: 'Barbados' },
    { key: 'by', value: 'Belarus', flag: 'by', text: 'Belarus' },
    { key: 'be', value: 'Belgium', flag: 'be', text: 'Belgium' },
    { key: 'bz', value: 'Belize', flag: 'bz', text: 'Belize' },
    { key: 'bj', value: 'Benin', flag: 'bj', text: 'Benin' },
    { key: 'bm', value: 'Bermuda', flag: 'bm', text: 'Bermuda' },
    { key: 'bt', value: 'Bhutan', flag: 'bt', text: 'Bhutan' },
    { key: 'bo', value: 'Bolivia', flag: 'bo', text: 'Bolivia' },
    { key: 'ba', value: 'Bosnia', flag: 'ba', text: 'Bosnia' },
    { key: 'bw', value: 'Botswana', flag: 'bw', text: 'Botswana' },
    { key: 'br', value: 'Brazil', flag: 'br', text: 'Brazil' },
    { key: 'bg', value: 'Bulgaria', flag: 'bg', text: 'Bulgaria' },
    { key: 'bf', value: 'Burkina Faso', flag: 'bf', text: 'Burkina Faso' },
    { key: 'bi', value: 'Burundi', flag: 'bi', text: 'Burundi' },
    { key: 'tc', value: 'Caicos Islands', flag: 'tc', text: 'Caicos Islands' },
    { key: 'kh', value: 'Cambodia', flag: 'kh', text: 'Cambodia' },
    { key: 'cm', value: 'Cameroon', flag: 'cm', text: 'Cameroon' },
    { key: 'ca', value: 'Canada', flag: 'ca', text: 'Canada' },
    { key: 'cv', value: 'Cape Verde', flag: 'cv', text: 'Cape Verde' },
    { key: 'ky', value: 'Cayman Islands', flag: 'ky', text: 'Cayman Islands' },
    { key: 'cf', value: 'Central African Republic', flag: 'cf', text: 'Central African Republic' },
    { key: 'td', value: 'Chad', flag: 'td', text: 'Chad' },
    { key: 'cl', value: 'Chile', flag: 'cl', text: 'Chile' },
    { key: 'cn', value: 'China', flag: 'cn', text: 'China' },
    { key: 'co', value: 'Colombia', flag: 'co', text: 'Colombia' },
    { key: 'km', value: 'Comoros', flag: 'km', text: 'Comoros' },
    { key: 'cd', value: 'Congo', flag: 'cd', text: 'Congo' },
    { key: 'cg', value: 'Congo Brazzaville', flag: 'cg', text: 'Congo Brazzaville' },
    { key: 'cr', value: 'Costa Rica', flag: 'cr', text: 'Costa Rica' },
    { key: 'ci', value: "Cote D'Ivoire", flag: 'ci', text: "Cote D'Ivoire" },
    { key: 'hr', value: 'Croatia', flag: 'hr', text: 'Croatia' },
    { key: 'cu', value: 'Cuba', flag: 'cu', text: 'Cuba' },
    { key: 'cy', value: 'Cyprus', flag: 'cy', text: 'Cyprus' },
    { key: 'cz', value: 'Czech Republic', flag: 'cz', text: 'Czech Republic' },
    { key: 'dk', value: 'Denmark', flag: 'dk', text: 'Denmark' },
    { key: 'dj', value: 'Djibouti', flag: 'dj', text: 'Djibouti' },
    { key: 'do', value: 'Dominican Republic', flag: 'do', text: 'Dominican Republic' },
    { key: 'eu', value: 'Ecuador', flag: 'ec', text: 'Ecuador' },
    { key: 'eg', value: 'Egypt', flag: 'eg', text: 'Egypt' },
    { key: 'sv', value: 'El Salvador', flag: 'sv', text: 'El Salvador' },
    { key: 'gq', value: 'Equatorial Guinea', flag: 'gq', text: 'Equatorial Guinea' },
    { key: 'ee', value: 'Estonia', flag: 'ee', text: 'Estonia' },
    { key: 'er', value: 'Eritrea', flag: 'er', text: 'Eritrea' },
    { key: 'et', value: 'Ethiopia', flag: 'et', text: 'Ethiopia' },
    { key: 'fo', value: 'Faroe Islands', flag: 'fo', text: 'Faroe Islands' },
    { key: 'fj', value: 'Fiji', flag: 'fj', text: 'Fiji' },
    { key: 'fi', value: 'Finland', flag: 'fi', text: 'Finland' },
    { key: 'fr', value: 'France', flag: 'fr', text: 'France' },
    { key: 'gf', value: 'French Guiana', flag: 'gf', text: 'French Guiana' },
    { key: 'pf', value: 'French Polynesia', flag: 'pf', text: 'French Polynesia' },
    { key: 'tf', value: 'French Territories', flag: 'tf', text: 'French Territories' },
    { key: 'ga', value: 'Gabon', flag: 'ga', text: 'Gabon' },
    { key: 'gm', value: 'Gambia', flag: 'gm', text: 'Gambia' },
    { key: 'ge', value: 'Georgia', flag: 'ge', text: 'Georgia' },
    { key: 'de', value: 'Germany', flag: 'de', text: 'Germany' },
    { key: 'gh', value: 'Ghana', flag: 'gh', text: 'Ghana' },
    { key: 'gr', value: 'Greece', flag: 'gr', text: 'Greece' },
    { key: 'gl', value: 'Greenland', flag: 'gl', text: 'Greenland' },
    { key: 'gd', value: 'Grenada', flag: 'gd', text: 'Grenada' },
    { key: 'gp', value: 'Guadeloupe', flag: 'gp', text: 'Guadeloupe' },
    { key: 'gt', value: 'Guatemala', flag: 'gt', text: 'Guatemala' },
    { key: 'gn', value: 'Guinea', flag: 'gn', text: 'Guinea' },
    { key: 'gw', value: 'Guinea-Bissau', flag: 'gw', text: 'Guinea-Bissau' },
    { key: 'gy', value: 'Guyana', flag: 'gy', text: 'Guyana' },
    { key: 'ht', value: 'Haiti', flag: 'ht', text: 'Haiti' },
    { key: 'hn', value: 'Honduras', flag: 'hn', text: 'Honduras' },
    { key: 'hk', value: 'Hong Kong', flag: 'hk', text: 'Hong Kong' },
    { key: 'hu', value: 'Hungary', flag: 'hu', text: 'Hungary' },
    { key: 'is', value: 'Iceland', flag: 'is', text: 'Iceland' },
    { key: 'in', value: 'India', flag: 'in', text: 'India' },
    { key: 'id', value: 'Indonesia', flag: 'id', text: 'Indonesia' },
    { key: 'ir', value: 'Iran', flag: 'ir', text: 'Iran' },
    { key: 'iq', value: 'Iraq', flag: 'iq', text: 'Iraq' },
    { key: 'ie', value: 'Ireland', flag: 'ie', text: 'Ireland' },
    { key: 'il', value: 'Israel', flag: 'il', text: 'Israel' },
    { key: 'il', value: 'Italy', flag: 'it', text: 'Italy' },
    { key: 'jm', value: 'Jamaica', flag: 'jm', text: 'Jamaica' },
    { key: 'jp', value: 'Japan', flag: 'jp', text: 'Japan' },
    { key: 'jo', value: 'Jordan', flag: 'jo', text: 'Jordan' },
    { key: 'kz', value: 'Kazakhstan', flag: 'kz', text: 'Kazakhstan' },
    { key: 'ke', value: 'Kenya', flag: 'ke', text: 'Kenya' },
    { key: 'kw', value: 'Kuwait', flag: 'kw', text: 'Kuwait' },
    { key: 'lv', value: 'Latvia', flag: 'lv', text: 'Latvia' },
    { key: 'lb', value: 'Lebanon', flag: 'lb', text: 'Lebanon' },
    { key: 'ls', value: 'Lesotho', flag: 'ls', text: 'Lesotho' },
    { key: 'lr', value: 'Liberia', flag: 'lr', text: 'Liberia' },
    { key: 'ly', value: 'Libya', flag: 'ly', text: 'Libya' },
    { key: 'li', value: 'Liechtenstein', flag: 'li', text: 'Liechtenstein' },
    { key: 'lt', value: 'Lithuania', flag: 'lt', text: 'Lithuania' },
    { key: 'lu', value: 'Luxembourg', flag: 'lu', text: 'Luxembourg' },
    { key: 'mk', value: 'Macedonia', flag: 'mk', text: 'Macedonia' },
    { key: 'mg', value: 'Madagascar', flag: 'mg', text: 'Madagascar' },
    { key: 'mw', value: 'Malawi', flag: 'mw', text: 'Malawi' },
    { key: 'my', value: 'Malaysia', flag: 'my', text: 'Malaysia' },
    { key: 'mv', value: 'Maldives', flag: 'mv', text: 'Maldives' },
    { key: 'ml', value: 'Mali', flag: 'ml', text: 'Mali' },
    { key: 'mt', value: 'Malta', flag: 'mt', text: 'Malta' },
    { key: 'mq', value: 'Martinique', flag: 'mq', text: 'Martinique' },
    { key: 'mr', value: 'Mauritania', flag: 'mr', text: 'Mauritania' },
    { key: 'mu', value: 'Mauritius', flag: 'mu', text: 'Mauritius' },
    { key: 'mx', value: 'Mexico', flag: 'mx', text: 'Mexico' },
    { key: 'md', value: 'Moldova', flag: 'md', text: 'Moldova' },
    { key: 'mc', value: 'Monaco', flag: 'mc', text: 'Monaco' },
    { key: 'mn', value: 'Mongolia', flag: 'mn', text: 'Mongolia' },
    { key: 'me', value: 'Montenegro', flag: 'me', text: 'Montenegro' },
    { key: 'ma', value: 'Morocco', flag: 'ma', text: 'Morocco' },
    { key: 'mz', value: 'Mozambique', flag: 'mz', text: 'Mozambique' },
    { key: 'na', value: 'Namibia', flag: 'na', text: 'Namibia' },
    { key: 'np', value: 'Nepal', flag: 'np', text: 'Nepal' },
    { key: 'nl', value: 'Netherlands', flag: 'nl', text: 'Netherlands' },
    { key: 'pg', value: 'New Guinea', flag: 'pg', text: 'New Guinea' },
    { key: 'nz', value: 'New Zealand', flag: 'nz', text: 'New Zealand' },
    { key: 'ni', value: 'Nicaragua', flag: 'ni', text: 'Nicaragua' },
    { key: 'ne', value: 'Niger', flag: 'ne', text: 'Niger' },
    { key: 'ng', value: 'Nigeria', flag: 'ng', text: 'Nigeria' },
    { key: 'kp', value: 'North Korea', flag: 'kp', text: 'North Korea' },
    { key: 'no', value: 'Norway', flag: 'no', text: 'Norway' },
    { key: 'pk', value: 'Pakistan', flag: 'pk', text: 'Pakistan' },
    { key: 'ps', value: 'Palestine', flag: 'ps', text: 'Palestine' },
    { key: 'pa', value: 'Panama', flag: 'pa', text: 'Panama' },
    { key: 'py', value: 'Paraguay', flag: 'py', text: 'Paraguay' },
    { key: 'py', value: 'Paraguay', flag: 'py', text: 'Paraguay' },
    { key: 'pe', value: 'Peru', flag: 'pe', text: 'Peru' },
    { key: 'ph', value: 'Philippines', flag: 'ph', text: 'Philippines' },
    { key: 'pl', value: 'Poland', flag: 'pl', text: 'Poland' },
    { key: 'pt', value: 'Portugal', flag: 'pt', text: 'Portugal' },
    { key: 'pr', value: 'Puerto Rico', flag: 'pr', text: 'Puerto Rico' },
    { key: 'qa', value: 'Qatar', flag: 'qa', text: 'Qatar' },
    { key: 'ro', value: 'Romania', flag: 'ro', text: 'Romania' },
    { key: 'ru', value: 'Russia', flag: 'ru', text: 'Russia' },
    { key: 'rw', value: 'Rwanda', flag: 'rw', text: 'Rwanda' },
    { key: 'ws', value: 'Samoa', flag: 'ws', text: 'Samoa' },
    { key: 'st', value: 'Sao Tome', flag: 'st', text: 'Sao Tome' },
    { key: 'sa', value: 'Saudi Arabia', flag: 'sa', text: 'Saudi Arabia' },
    { key: 'gb sct', value: 'Scotland', flag: 'gb sct', text: 'Scotland' },
    { key: 'sn', value: 'Senegal', flag: 'sn', text: 'Senegal' },
    { key: 'cs', value: 'Serbia', flag: 'cs', text: 'Serbia' },
    { key: 'sc', value: 'Seychelles', flag: 'sc', text: 'Seychelles' },
    { key: 'sl', value: 'Sierra Leone', flag: 'sl', text: 'Sierra Leone' },
    { key: 'sg', value: 'Singapore', flag: 'sg', text: 'Singapore' },
    { key: 'sk', value: 'Slovakia', flag: 'sk', text: 'Slovakia' },
    { key: 'si', value: 'Slovenia', flag: 'si', text: 'Slovenia' },
    { key: 'so', value: 'Somalia', flag: 'so', text: 'Somalia' },
    { key: 'za', value: 'South Africa', flag: 'za', text: 'South Africa' },
    { key: 'kr', value: 'South Korea', flag: 'kr', text: 'South Korea' },
    { key: 'es', value: 'Spain', flag: 'es', text: 'Spain' },
    { key: 'lk', value: 'Sri Lanka', flag: 'lk', text: 'Sri Lanka' },
    { key: 'sd', value: 'Sudan', flag: 'sd', text: 'Sudan' },
    { key: 'sr', value: 'Suriname', flag: 'sr', text: 'Suriname' },
    { key: 'sz', value: 'Swaziland', flag: 'sz', text: 'Swaziland' },
    { key: 'se', value: 'Sweden', flag: 'se', text: 'Sweden' },
    { key: 'ch', value: 'Switzerland', flag: 'ch', text: 'Switzerland' },
    { key: 'sy', value: 'Syria', flag: 'sy', text: 'Syria' },
    { key: 'tw', value: 'Taiwan', flag: 'tw', text: 'Taiwan' },
    { key: 'tz', value: 'Tanzania', flag: 'tz', text: 'Tanzania' },
    { key: 'th', value: 'Thailand', flag: 'th', text: 'Thailand' },
    { key: 'tg', value: 'Togo', flag: 'tg', text: 'Togo' },
    { key: 'tt', value: 'Trinidad', flag: 'tt', text: 'Trinidad' },
    { key: 'tn', value: 'Tunisia', flag: 'tn', text: 'Tunisia' },
    { key: 'tr', value: 'Turkey', flag: 'tr', text: 'Turkey' },
    { key: 'ae', value: 'U.A.E', flag: 'ae', text: 'U.A.E' },
    { key: 'ug', value: 'Uganda', flag: 'ug', text: 'Uganda' },
    { key: 'ua', value: 'Ukraine', flag: 'ua', text: 'Ukraine' },
    { key: 'uk', value: 'United Kingdom', flag: 'uk', text: 'United Kingdom' },
    { key: 'us', value: 'United States', flag: 'us', text: 'United States' },
    { key: 'uy', value: 'Uruguay', flag: 'uy', text: 'Uruguay' },
    { key: 'uz', value: 'Uzbekistan', flag: 'uz', text: 'Uzbekistan' },
    { key: 've', value: 'Venezuela', flag: 've', text: 'Venezuela' },
    { key: 'vn', value: 'Vietnam', flag: 'vn', text: 'Vietnam' },
    { key: 'gb wls', value: 'Wales', flag: 'gb wls', text: 'Wales' },
    { key: 'ye', value: 'Yemen', flag: 'ye', text: 'Yemen' },
    { key: 'zm', value: 'Zambia', flag: 'zm', text: 'Zambia' },
    { key: 'zw', value: 'Zimbabwe', flag: 'zw', text: 'Zimbabwe' },
  ]

 const phoneExts = [
   {key: '+93', text: '+93', value: '+93'},
   {key: '+355', text: '+355', value: '+355'},
   {key: '+213', text: '+213', value: '+213'},
   {key: '+1-684', text: '+1-684', value: '+1-684'},
   {key: '+376', text: '+376', value: '+376'},
   {key: '+244', text: '+244', value: '+244'},
   {key: '+1-264', text: '+1-264', value: '+1-264'},
   {key: '+1-268', text: '+1-268', value: '+1-268'},
   {key: '+54', text: '+54', value: '+54'},
   {key: '+374', text: '+374', value: '+374'},
   {key: '+297', text: '+297', value: '+297'},
   {key: '+61', text: '+61', value: '+61'},
   {key: '+43', text: '+43', value: '+43'},
   {key: '+994', text: '+994', value: '+994'},
   {key: '+1-242', text: '+1-242', value: '+1-242'},
   {key: '+973', text: '+973', value: '+973'},
   {key: '+880', text: '+880', value: '+880'},
   {key: '+1-246', text: '+1-246', value: '+1-246'},
   {key: '+375', text: '+375', value: '+375'},
   {key: '+32', text: '+32', value: '+32'},
   {key: '+501', text: '+501', value: '+501'},
   {key: '+229', text: '+229', value: '+229'},
   {key: '+1-441', text: '+1-441', value: '+1-441'},
   {key: '+975', text: '+975', value: '+975'},
   {key: '+591', text: '+591', value: '+591'},
   {key: '+387', text: '+387', value: '+387'},
   {key: '+267', text: '+267', value: '+267'},
   {key: '+55', text: '+55', value: '+55'},
   {key: '+359', text: '+359', value: '+359'},
   {key: '+226', text: '+226', value: '+226'},
   {key: '+257', text: '+257', value: '+257'},
   {key: '+855', text: '+855', value: '+855'},
   {key: '+237', text: '+237', value: '+237'},
   {key: '+1', text: '+1', value: '+1'},
   {key: '+238', text: '+238', value: '+238'},
   {key: '+1-345', text: '+1-345', value: '+1-345'},
   {key: '+236', text: '+236', value: '+236'},
   {key: '+235', text: '+235', value: '+235'},
   {key: '+56', text: '+56', value: '+56'},
   {key: '+86', text: '+86', value: '+86'},
   {key: '+57', text: '+57', value: '+57'},
   {key: '+269', text: '+269', value: '+269'},
   {key: '+506', text: '+506', value: '+506'},
   {key: '+385', text: '+385', value: '+385'},
   {key: '+53', text: '+53', value: '+53'},
   {key: '+357', text: '+357', value: '+357'},
   {key: '+420', text: '+420', value: '+420'},
   {key: '+243', text: '+243', value: '+243'},
   {key: '+45', text: '+45', value: '+45'},
   {key: '+253', text: '+253', value: '+253'},
   {key: '+1-809', text: '+1-809', value: '+1-809'},
   {key: '+1-829', text: '+1-829', value: '+1-829'},
   {key: '+1-849', text: '+1-849', value: '+1-849'},
   {key: '+593', text: '+593', value: '+593'},
   {key: '+20', text: '+20', value: '+20'},
   {key: '+503', text: '+503', value: '+503'},
   {key: '+240', text: '+240', value: '+240'},
   {key: '+291', text: '+291', value: '+291'},
   {key: '+372', text: '+372', value: '+372'},
   {key: '+251', text: '+251', value: '+251'},
   {key: '+679', text: '+679', value: '+679'},
   {key: '+358', text: '+358', value: '+358'},
   {key: '+33', text: '+33', value: '+33'},
   {key: '+689', text: '+689', value: '+689'},
   {key: '+241', text: '+241', value: '+241'},
   {key: '+220', text: '+220', value: '+220'},
   {key: '+995', text: '+995', value: '+995'},
   {key: '+49', text: '+49', value: '+49'},
   {key: '+233', text: '+233', value: '+233'},
   {key: '+30', text: '+30', value: '+30'},
   {key: '+229', text: '+229', value: '+229'},
   {key: '+1-473', text: '+1-473', value: '+1-473'},
   {key: '+502', text: '+502', value: '+502'},
   {key: '+224', text: '+224', value: '+224'},
   {key: '+245', text: '+245', value: '+245'},
   {key: '+592', text: '+592', value: '+592'},
   {key: '+509', text: '+509', value: '+509'},
   {key: '+504', text: '+504', value: '+504'},
   {key: '+852', text: '+852', value: '+852'},
   {key: '+36', text: '+36', value: '+36'},
   {key: '+354', text: '+354', value: '+354'},
   {key: '+91', text: '+91', value: '+91'},
   {key: '+62', text: '+62', value: '+62'},
   {key: '+98', text: '+98', value: '+98'},
   {key: '+964', text: '+964', value: '+964'},
   {key: '+353', text: '+353', value: '+353'},
   {key: '+972', text: '+972', value: '+972'},
   {key: '+39', text: '+39', value: '+39'},
   {key: '+225', text: '+225', value: '+225'},
   {key: '+1-876', text: '+1-876', value: '+1-876'},
   {key: '+81', text: '+81', value: '+81'},
   {key: '+962', text: '+962', value: '+962'},
   {key: '+7', text: '+7', value: '+7'},
   {key: '+254', text: '+254', value: '+254'},
   {key: '+965', text: '+965', value: '+965'},
   {key: '+371', text: '+371', value: '+371'},
   {key: '+961', text: '+961', value: '+961'},
   {key: '+266', text: '+266', value: '+266'},
   {key: '+231', text: '+231', value: '+231'},
   {key: '+218', text: '+218', value: '+218'},
   {key: '+423', text: '+423', value: '+423'},
   {key: '+370', text: '+370', value: '+370'},
   {key: '+352', text: '+352', value: '+352'},
   {key: '+389', text: '+389', value: '+389'},
   {key: '+261', text: '+261', value: '+261'},
   {key: '+265', text: '+265', value: '+265'},
   {key: '+60', text: '+60', value: '+60'},
   {key: '+960', text: '+960', value: '+960'},
   {key: '+223', text: '+223', value: '+223'},
   {key: '+356', text: '+356', value: '+356'},
   {key: '+222', text: '+222', value: '+222'},
   {key: '+230', text: '+230', value: '+230'},
   {key: '+52', text: '+52', value: '+52'},
   {key: '+373', text: '+373', value: '+373'},
   {key: '+77', text: '+77', value: '+77'},
   {key: '+976', text: '+976', value: '+976'},
   {key: '+382', text: '+382', value: '+382'},
   {key: '+212', text: '+212', value: '+212'},
   {key: '+258', text: '+258', value: '+258'},
   {key: '+264', text: '+264', value: '+264'},
   {key: '+977', text: '+977', value: '+977'},
   {key: '+31', text: '+31', value: '+31'},
   {key: '+64', text: '+64', value: '+64'},
   {key: '+505', text: '+505', value: '+505'},
   {key: '+227', text: '+227', value: '+227'},
   {key: '+234', text: '+234', value: '+234'},
   {key: '+850', text: '+850', value: '+850'},
   {key: '+47', text: '+47', value: '+47'},
   {key: '+92', text: '+92', value: '+92'},
   {key: '+970', text: '+970', value: '+970'},
   {key: '+507', text: '+507', value: '+507'},
   {key: '+595', text: '+595', value: '+595'},
   {key: '+51', text: '+51', value: '+51'},
   {key: '+63', text: '+63', value: '+63'},
   {key: '+48', text: '+48', value: '+48'},
   {key: '+351', text: '+351', value: '+351'},
   {key: '+1-787', text: '+1-787', value: '+1-787'},
   {key: '+1-939', text: '+1-939', value: '+1-939'},
   {key: '+974', text: '+974', value: '+974'},
   {key: '+242', text: '+242', value: '+242'},
   {key: '+40', text: '+40', value: '+40'},
   {key: '+7', text: '+7', value: '+7'},
   {key: '+250', text: '+250', value: '+250'},
   {key: '+685', text: '+685', value: '+685'},
   {key: '+239', text: '+239', value: '+239'},
   {key: '+966', text: '+966', value: '+966'},
   {key: '+221', text: '+221', value: '+221'},
   {key: '+381', text: '+381', value: '+381'},
   {key: '+248', text: '+248', value: '+248'},
   {key: '+232', text: '+232', value: '+232'},
   {key: '+65', text: '+65', value: '+65'},
   {key: '+421', text: '+421', value: '+421'},
   {key: '+386', text: '+386', value: '+386'},
   {key: '+252', text: '+252', value: '+252'},
   {key: '+27', text: '+27', value: '+27'},
   {key: '+82', text: '+82', value: '+82'},
   {key: '+34', text: '+34', value: '+34'},
   {key: '+94', text: '+94', value: '+94'},
   {key: '+249', text: '+249', value: '+249'},
   {key: '+597', text: '+597', value: '+597'},
   {key: '+268', text: '+268', value: '+268'},
   {key: '+46', text: '+46', value: '+46'},
   {key: '+41', text: '+41', value: '+41'},
   {key: '+963', text: '+963', value: '+963'},
   {key: '+886', text: '+886', value: '+886'},
   {key: '+255', text: '+255', value: '+255'},
   {key: '+66', text: '+66', value: '+66'},
   {key: '+228', text: '+228', value: '+228'},
   {key: '+1-868', text: '+1-868', value: '+1-868'},
   {key: '+216', text: '+216', value: '+216'},
   {key: '+90', text: '+90', value: '+90'},
   {key: '+1-649', text: '+1-649', value: '+1-649'},
   {key: '+256', text: '+256', value: '+256'},
   {key: '+380', text: '+380', value: '+380'},
   {key: '+971', text: '+971', value: '+971'},
   {key: '+44', text: '+44', value: '+44'},
   {key: '+598', text: '+598', value: '+598'},
   {key: '+998', text: '+998', value: '+998'},
   {key: '+58', text: '+58', value: '+58'},
   {key: '+84', text: '+84', value: '+84'},
   {key: '+967', text: '+967', value: '+967'},
   {key: '+260', text: '+260', value: '+260'},
   {key: '+263', text: '+263', value: '+263'},
 ]

  const [loading, setLoader] = React.useState(false);

  const updateBasicInfo = e => {
    e.preventDefault();
    setLoader(true);
    docref.update({
      'eventName': values.eventTitle ? values.eventTitle : event.eventName,
      'eventCategory': eventCategory ? eventCategory : event.eventCategory,
      'eventType': eventType ? eventType : event.eventType,
      'eventOrganizer': values.eventOrganizer ? values.eventOrganizer : event.eventOrganizer
    })
    .then(function() {
      setLoader(false);
      setValues({
        'eventTitle': '',
        'eventType': '',
        'eventOrganizer': ''
      })
      console.log("Document successfully updated!");
    })
    .catch(function(error) {
    // The document probably doesn't exist.
    console.error("Error updating document: ", error);
  });
}

  const updateLocationInfo = e => {
    e.preventDefault();
    setLoader(true);
    docref.update({
      'eventVenue': values.eventVenue ? values.eventVenue : event.eventVenue,
      'eventStreet1': values.eventStreet1 ? values.eventStreet1 : event.eventStreet1,
      'eventStreet2': values.eventStreet2 ? values.eventStreet2 : event.eventStreet2,
      'eventCity': values.eventCity ? values.eventCity : event.eventCity,
      'eventProvince': values.eventProvince ? values.eventProvince : event.eventProvince,
      'eventCountry': eventCountry ? eventCountry : event.eventCountry
    }).then(function() {
          setLoader(false);
          setValues({
            'eventVenue': '',
            'eventStreet1': '',
            'eventStreet2': '',
            'eventCity': '',
            'eventProvince': '',
          });
          setCountry('');
          console.log("Document successfully updated!");
        })
        .catch(function(error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
      })
  }


  const updateDateTime = e => {
    e.preventDefault();
    setLoader(true);
    docref.update({
       'startDate': startDate ? startDate : event.startDate,
       'formattedStartDate': new Date(`${startDate} ${startTime}`),
       'startTime': startTime ? startTime : event.startTime,
       'endDate': endDate ? endDate : event.endDate,
       'formattedEndDate': new Date(`${endDate} ${endTime}`),
       'endTime': endTime ? endTime : event.endTime
    }).then(function() {
          setLoader(false);
          setStartDate('');
          setEndDate('');
          setStartTime('');
          setEndTime('');
          console.log("Document successfully updated!");
        })
        .catch(function(error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
      })
  }

  const updateDetails = e => {
    e.preventDefault();
    setLoader(true);
      docref.update({
        'eventDetails': convertToRaw(editorState.getCurrentContent())
      }).then(function() {
            setLoader(false);
            setValues({
              'eventDetails': ''
            })
            console.log("Document successfully updated!");
          })
          .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
  }

  const updateImage = e => {
    e.preventDefault();
    setLoader(true);
    if (eventImage) {
      const uploadImage = storage.child(`EventImages/${event.eventName}`).put(eventImage);
      uploadImage.on('state_changed',
      (snapshot) => {

      },
      (error) => {
        console.log(error);
      },
      () => {
        uploadImage.snapshot.ref.getDownloadURL().then((url) => {
          docref.update({
            eventImgUrl: url
          }).then(() => {
            setLoader(false);
            setPrevUrl('');
          })
        })
      }
    )
    }
  }

  const updateOrganizerInfo = e => {
    e.preventDefault();
    setLoader(true);
    docref.update({
      'eventEmail': values.eventEmail ? values.eventEmail : event.eventEmail,
      'eventPhone': values.eventPhone ? `${phoneCode}${values.eventPhone}` : event.eventPhone
    }).then(function() {
          setLoader(false);
          setValues({
            'eventPhone': '',
            'eventEmail': '',
          })
          console.log("Document successfully updated!");
        })
        .catch(function(error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
      });
  }

  const createTicket = e => {
    e.preventDefault();
    setLoader(true);
    docref.collection('tickets').add({
      ticketName: values.ticketName,
      ticketQuantity: parseInt(values.ticketQuantity),
      ticketPrice: `${currencyCode}${values.ticketPrice}`,
      ticketDetails: values.ticketDetails,
      ticketSaleStartDate: salesStartDate,
      ticketSaleEndDate: salesEndDate,
      ticketSaleStartTime: salesStartTime,
      ticketSaleEndTime: salesEndTime,
      formattedticketSaleStartDate: new Date(`${salesStartDate} ${salesStartTime}`),
      formattedticketSaleEndDate: new Date(`${salesEndDate} ${salesEndTime}`)
    }).then(() => {
      setLoader(false);
      setValues({
        ticketName: '',
        ticketQuantity: 0,
        ticketPrice: 0,
        ticketDetails: '',
      });
      setSalesStartDate('');
      setSalesEndDate('');
      setSalesStartTime('');
      setSalesEndTime('');
    });
  }

  const eventDetailsPane = [
    {
      menuItem: 'Basic Info',
      render: () =>
      <Tab.Pane attached={false}>
        <Form loading={loading} onSubmit={updateBasicInfo}>
          <Form.Field>
            <label>Event Title</label>
            <input placeholder={event.eventName} name='eventTitle' value={values.eventTitle} onChange={handleChange('eventTitle')}/>
          </Form.Field>
          <Form.Group>
            <Form.Dropdown selection label='Event Category' placeholder={event.eventCategory} value={eventCategory} name='eventCategory' onChange={handleCategory} options={categories}/>
            <Form.Dropdown selection multiple label='Event Type' placeholder={event.eventType} value={eventType} name='eventType' onChange={handleType} options={types}/>
          </Form.Group>
          <Form.Field width={10}>
            <label>Event Organizer</label>
            <input placeholder={event.eventOrganizer} name='eventOrganizer' value={values.eventOrganizer} onChange={handleChange('eventOrganizer')}/>
          </Form.Field>
          <Form.Button primary content='Update Info' type='submit'/>
          <Divider hidden/>
        </Form>
      </Tab.Pane>,
    },
    {
      menuItem: 'Location',
      render: () =>
      <Tab.Pane attached={false}>
        <Form loading={loading} onSubmit={updateLocationInfo}>
          <Form.Field width={10}>
            <label>Event Venue</label>
            <input placeholder={event.eventVenue} value={values.eventVenue} onChange={handleChange('eventVenue')} name='eventVenue'/>
          </Form.Field>
          <Form.Group>
            <Form.Input label='Street Address 1' placeholder={event.eventStreet1} value={values.eventStreet1} name='eventStreet1' onChange={handleChange('eventStreet1')}/>
            <Form.Input label='Street Address 2' placeholder={event.eventStreet2} value={values.eventStreet2} name='eventStreet2' onChange={handleChange('eventStreet2')}/>
          </Form.Group>
          <Form.Group>
            <Form.Input label='City' placeholder={event.eventCity} value={values.eventCity} name='eventCity' onChange={handleChange('eventCity')}/>
            <Form.Input label='State/Province' placeholder={event.eventProvince} value={values.eventProvince} name='eventProvince' onChange={handleChange('eventProvince')}/>
          </Form.Group>
          <Form.Select label='Country' placeholder={event.eventCountry} width={6} value={eventCountry} name='eventCountry' onChange={handleCountry} options={countries}/>
          <Form.Button primary content='Update Info' type='submit'/>
          <Divider hidden/>
        </Form>
      </Tab.Pane>,
    },
    {
      menuItem: 'Date & Time',
      render: () =>
      <Tab.Pane attached={false}>
        <Form loading={loading} onSubmit={updateDateTime}>
          <Form.Group>
            <DateInput
              label='Start Date'
              clearable
              name="startDate"
              minDate={"2070-01-31"}
              placeholder={event.startDate}
              dateFormat="dddd, DD MMMM YYYY"
              value={startDate}
              iconPosition="left"
              onChange={handleStartDateChange}
              hideMobileKeyboard={true}
              closable={true}
            />
            <TimeInput
              label='Start Time'
              clearable
              name="startTime"
              placeholder={event.startTime}
              timeFormat="AMPM"
              value={startTime}
              iconPosition="left"
              onChange={handleStartTimeChange}
              hideMobileKeyboard={true}
              closable={true}
            />
          </Form.Group>
          <Form.Group>
            <DateInput
              label='End Date'
              clearable
              name="endDate"
              placeholder={event.endDate}
              dateFormat="dddd, DD MMMM YYYY"
              value={endDate}
              iconPosition="left"
              onChange={handleEndDateChange}
              hideMobileKeyboard={true}
              closable={true}
            />
            <TimeInput
              label='End Time'
              clearable
              name="endTime"
              placeholder={event.endTime}
              timeFormat="AMPM"
              value={endTime}
              iconPosition="left"
              onChange={handleEndTimeChange}
              hideMobileKeyboard={true}
              closable={true}
            />
          </Form.Group>
          <Divider hidden/>
          <Form.Button primary content='Update Info' type='submit'/>
          <Divider hidden/>
        </Form>
      </Tab.Pane>,
    },
    {
      menuItem: 'Details',
      render: () =>
      <Tab.Pane attached={false}>
        <Form loading={loading} onSubmit={updateDetails}>
          <EditorWrapper>
            <Toolbar editorState={editorState} updateEditorState={updateEditorState}/>

            <EditorContainer>
              <Editor placeholder='' editorState={editorState} onChange={setEditorState} handleKeyCommand={handleKeyCommand} customStyleFn={customStyleFn}/>
            </EditorContainer>
          </EditorWrapper>
          <Divider hidden/>
          <Form.Button primary content='Update Info' type='submit'/>
          <Divider hidden/>
        </Form>
      </Tab.Pane>
    },
    {
      menuItem: 'Event Image',
      render: () =>
      <Tab.Pane>
        <Form loading={loading} onSubmit={updateImage}>
          <Form.Field>
            <label>Change the Main Image for your event</label>
            <Button secondary type='button' content='Select image' icon='camera' labelPosition='left' onClick={() => fileInputRef.current.click()}/>
            <input ref={fileInputRef} type='file' hidden onChange={handleImageChange}/>
          </Form.Field>
          <Image src={prevUrl ? prevUrl : event.eventImgUrl} size='large' rounded/>
          <Divider hidden/>
          <Form.Button primary content='Update Image' type='submit'/>
          <Divider hidden/>
        </Form>
      </Tab.Pane>
    },
    {
      menuItem: 'Organizer Info',
      render: () =>
      <Tab.Pane attached={false}>
        <Form loading={loading} onSubmit={updateOrganizerInfo}>
          <Form.Group>
            <Form.Field width={7}>
              <label>Organizer Email Address</label>
              <Input placeholder={event.eventEmail} value={values.eventEmail} name='eventEmail' onChange={handleChange('eventEmail')}/>
            </Form.Field>
            <Form.Field width={7}>
              <label>Organizer Phone Number</label>
              <Input label={<Dropdown search inline defaultValue={phoneCode} options={phoneExts} value={phoneCode} onChange={handleCode}/>} labelPosition='left' value={values.eventPhone} placeholder={event.eventPhone} name='eventPhone' onChange={handleChange('eventPhone')}/>
            </Form.Field>
          </Form.Group>
          <Divider hidden/>
          <Form.Button primary content='Update Info' type='submit'/>
          <Divider hidden/>
        </Form>
      </Tab.Pane>
    },
    {
      menuItem: 'Tickets',
      render: () =>
      <Tab.Pane attached={false}>
        <Form loading={loading} onSubmit={createTicket}>
          <Form.Group>
            <Form.Field>
              <label>Ticket Name</label>
              <Input placeholder='Enter Ticket Name' value={values.ticketName} name='ticketName' onChange={handleChange('ticketName')}/>
            </Form.Field>
            <Form.Field>
              <label>Ticket Quantity</label>
              <Input placeholder='Enter Quantity available' type='number' min='0' value={values.ticketQuantity} name='ticketQuantity' onChange={handleChange('ticketQuantity')}/>
            </Form.Field>
          </Form.Group>
          <Form.Field width={6}>
            <label>Price</label>
            <Input labelPosition='left' value={values.ticketPrice} name='ticketPrice' min='0' onChange={handleChange('ticketPrice')}><Label><Dropdown options={currency} value={currencyCode} onChange={handleCurrency}/></Label><input/><Label>.00</Label></Input>
          </Form.Field>
          <Form.Group>
            <Form.Field>
              <DateInput
                label='Sales Start Date'
                clearable
                name="startDate"
                minDate={"2070-01-31"}
                // placeholder={event.startDate}
                dateFormat="dddd, DD MMMM YYYY"
                value={salesStartDate}
                iconPosition="left"
                onChange={handleSalesStartDateChange}
                hideMobileKeyboard={true}
                closable={true}
              />
            </Form.Field>
            <Form.Field>
              <TimeInput
                label='Sales Start Time'
                clearable
                name="endTime"
                // placeholder={event.endTime}
                timeFormat="AMPM"
                value={salesStartTime}
                iconPosition="left"
                onChange={handleSalesStartTimeChange}
                hideMobileKeyboard={true}
                closable={true}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field>
              <DateInput
                label='Sales End Date'
                clearable
                name="startDate"
                minDate={"2070-01-31"}
                // placeholder={event.startDate}
                dateFormat="dddd, DD MMMM YYYY"
                value={salesEndDate}
                iconPosition="left"
                onChange={handleSalesEndDateChange}
                hideMobileKeyboard={true}
                closable={true}
              />
            </Form.Field>
            <Form.Field>
              <TimeInput
                label='Sales End Time'
                clearable
                name="endTime"
                // placeholder={event.endTime}
                timeFormat="AMPM"
                value={salesEndTime}
                iconPosition="left"
                onChange={handleSalesEndTimeChange}
                hideMobileKeyboard={true}
                closable={true}
              />
            </Form.Field>
          </Form.Group>
          <Form.Field>
            <Form.TextArea label='Ticket Details' placeholder='Describe what this ticket entails to a potential client' name='ticketDetails' value={values.ticketDetails} onChange={handleChange('ticketDetails')} style={{ minHeight: 250 }}/>
          </Form.Field>
          <Form.Button primary content='Create Ticket' type='submit'/>
        </Form>
      </Tab.Pane>
    },
  ]

  return (
    <Tab menu={{ fluid: true, borderless: true, secondary: true }} style={{ borderWidth: 0 }} grid={{ tabWidth: 12 }} panes={eventDetailsPane}/>
  );
}
